/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable  dot-notation */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
    array, bool, func, object, string,
} from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';

import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import ReactHTMLParser from 'react-html-parser';
import ModalWrapper from '../../../../EnterpriseCheckout/Common/ModalWrapper/ModalWrapper';
import { getSSRDeviceType } from '../../../../../../../../state/ducks/App/App-Selectors';

const styles = (theme) => ({
    root: {
        color: theme.palette.common?.black,
        padding: '10px 0',
    },
    contAccordion: {
        boxShadow: 'none',
        '& $contAccExpanded': {
            margin: 0,
            minHeight: '24px',
        },
    },
    title: {
        fontWeight: 'bold',
        fontSize: '1em',
    },
    contentInfo: {
        margin: '0 0 10px 0',
    },
    contAccSummaryRoot: {
        minHeight: '24px',
    },
    contAccSummary: {
        margin: 0,
        '&$contAccExpanded': {
            margin: 0,
            minHeight: '24px',
        },
    },
    contAccExpanded: {
        margin: 0,
        minHeight: '24px',
    },
    toggleIcon: {
        padding: '0',
    },
    expandIconWrapper: {
        padding: '0px 12px',
        margin: 0,
        width: '36px',
    },
    titleExpand: {
        fontSize: '14px',
        textDecoration: 'underline',
    },
});

const RegulatoryFeeInformation = ({
    classes, deliveryInfoList, isOpen, handleOpenToggled, toggledKey, dataDictionary,
}) => {
    const informationKeys = Object.keys(deliveryInfoList) || [];
    const [expanded, setExpanded] = useState(`regulatory-fee-${informationKeys[0]}`);

    const deviceType = useSelector(getSSRDeviceType);
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const mobileTitle = dataDictionary?.['Order has the following fee/s'] || 'Order has the following fee/s:';
    const desktopTitle = dataDictionary?.['This order includes the following regulatory fee/s'] || 'This order includes the following regulatory fee/s:';
    const expandTitle = dataDictionary?.['Expand'] ||  'Expand';
    const collapseTitle = dataDictionary?.['Collapse'] || 'Collapse';

    if (informationKeys.length > 0) {
        return (
            <ModalWrapper
                modalTitle={deviceType === 'mobile' ? mobileTitle : desktopTitle}
                isOpen={isOpen}
                onCloseModal={() => handleOpenToggled(toggledKey)}
                btnClose
                modalSize={deviceType === 'mobile' ? 'lg' : 'md'}
                modalContent={(
                    <Grid container className={classes.root}>
                        {
                            informationKeys.map((keyInfo) => {
                                const regulatoryKey = `regulatory-fee-${keyInfo}`;
                                return (
                                    <Accordion
                                        key={regulatoryKey}
                                        id={regulatoryKey}
                                        data-testid={regulatoryKey}
                                        className={classes.contAccordion}
                                        expanded={expanded === regulatoryKey}
                                        onChange={handleChange(regulatoryKey)}
                                    >
                                        <AccordionSummary
                                            id={`panel${keyInfo}`}
                                            data-testid={`panel${keyInfo}`}
                                            classes={{
                                                root: classes.contAccSummaryRoot,
                                                content: classes.contAccSummary,
                                                expanded: classes.contAccExpanded,
                                                expandIcon: classes.expandIconWrapper,
                                            }}
                                            expandIcon={<ExpandMoreIcon className={classes.toggleIcon} />}
                                            aria-controls={`panel${keyInfo}`}
                                        >
                                            <Grid container>
                                                <Grid item xs={6} align="left">
                                                    <Typography className={classes.title}>{deliveryInfoList[keyInfo].title}</Typography>
                                                </Grid>
                                                <Grid item xs={6} align="right">
                                                    <span className={classes.titleExpand}>{expanded === regulatoryKey ? expandTitle : collapseTitle}</span>
                                                </Grid>
                                            </Grid>

                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Grid id={`content${keyInfo}`} data-testid={`content${keyInfo}`} container className={classes.contentInfo}>
                                                {ReactHTMLParser(deliveryInfoList[keyInfo].content)}
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                );
                            })
                        }
                    </Grid>
                )}
            />

        );
    }
    return null;
};

RegulatoryFeeInformation.propTypes = {
    classes: object.isRequired,
    deliveryInfoList: array.isRequired,
    handleOpenToggled: func.isRequired,
    isOpen: bool.isRequired,
    toggledKey: string.isRequired,
    dataDictionary: object.isRequired,
};
RegulatoryFeeInformation.defaultProps = {
    // isConfirmationPage: false,
};

export default withStyles(styles)(RegulatoryFeeInformation);
